import { render, staticRenderFns } from "./BulkMessagesDialog.vue?vue&type=template&id=723279a6&"
import script from "./BulkMessagesDialog.vue?vue&type=script&lang=js&"
export * from "./BulkMessagesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports